export const POST_NORD_METHOD_TYPE = 'post_nord';
export const POST_NORD_POPUP_ID = POST_NORD_METHOD_TYPE;
export const MY_ACCOUNT_OVERLAY = 'customer_account';
